import { useProductData2 } from "@context/products";
import { GIFT_PACKAGES_HANDLES } from "@constants/GiftPackages";
import { useCurrentCountryCode, useProductPricing } from "./usePrices";

export default function useGiftPackages() {
  const countryCode = useCurrentCountryCode();
  const { data, isInitialLoading: productsLoading } = useProductData2(
    GIFT_PACKAGES_HANDLES,
    "short",
    countryCode
  );
  const { products, isInitialLoading: pricesLoading } = useProductPricing({ products: data });

  return { products, isInitialLoading: productsLoading || pricesLoading };
}
